import PutRequest from 'app/actions/PutRequest';

const ApplyChangeEmailAction =
  (email, hash, onSuccess, onError) => (dispatch) => {
    PutRequest({
      endPoint: `/user/apply-change-email`,
      params: { email, hash },
      onSuccess: () => {
        onSuccess();
      },
      onFailure: (error) => {
        onError();
        console.warn(error);
      },
    });
  };
export default ApplyChangeEmailAction;
